import script from "./PaymentMethodUSDT.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethodUSDT.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentMethodUSDT.vue?vue&type=style&index=0&id=7061cc72&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7061cc72"]])

export default __exports__